export { default } from './InfoCard'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Cards/InfoCard/index.js